import React, { useState, useEffect } from 'react'
import { Button, Input, Select, Table } from 'antd'
import 'aos/dist/aos.css'
import '../../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  DeleteHSNCodeMaster,
  GetHSNCodeMaster,
  SaveHSNCodeMaster,
  UpdateHSNCodeMaster,
} from '../../../AllAPI/MasterAPI/GeneralMasterApi'

const HSNCodeMaster = () => {
 
const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

  const [errors, setErrors] = useState({
    hsnCode: '',
    description: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [hsnCodeId, setHsnCodeId] = useState('')
  const [hsnCode, setHsnCode] = useState('')
  const [type, setType] = useState('')
  const [description, setDescription] = useState('')

  const [allhsnCode, setAllHsnCode] = useState([])
  const [updateButton, setUpdateButton] = useState(false)
  const [saveButton, setSaveButton] = useState(true)

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allhsnCode.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };
  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch HsnCode Names
  let isHsnCodeFetched = false
  useEffect(() => {
    if (isHsnCodeFetched) return
    fetchHsnCode()
    isHsnCodeFetched = true
  }, [])

  //=========GET HsnCode DATA============

  let isError = false

  const fetchHsnCode = async () => {
    try {
      const response = await axios.get(GetHSNCodeMaster, commonHeaders1)
      if (response.data !== null) {
        setAllHsnCode(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching HsnCode:', error)
        toast.error('Failed to fetch HsnCode data')
        isError = true
      }
    }
  }

  // const columns = [
  //   {
  //     title: 'Sr.No.',
  //     dataIndex: '',
  //     key: 'index',
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: 'HsnCode',
  //     dataIndex: 'hsnCode',
  //     key: 'hsnCode',
  //   },
  //   {
  //     title: 'Type',
  //     dataIndex: 'type',
  //     key: 'type',
  //     render: (text) => {
  //       return text === 1 ? 'Sales' : 'Purchase' ;
  //     },
  //   },
  //   {
  //     title: 'Description',
  //     dataIndex: 'description',
  //     key: 'description',
  //   },
  //   {
  //     title: 'Actions',
  //     key: 'actions',
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ]

  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'HsnCode',
    dataIndex: 'hsnCode',
    key: 'hsnCode',
    sorter: (a, b) => a.hsnCode.localeCompare(b.hsnCode), // Sorting alphabetically for hsnCode
  },
  {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    render: (text) => {
      return text === 1 ? 'Sales' : 'Purchase';
    },
    sorter: (a, b) => a.type - b.type, // Sorting numerically (1 for Sales, 2 for Purchase)
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description), // Sorting alphabetically for description
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
          onClick={() => handleEditDataButton(record)}
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
          onClick={() => handleDeleteData(record)}
        >
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  //=========CANCEL HsnCode DATA============
  const handleCancel = () => {
    setHsnCode('')
    setType('')
    setDescription('')
    setUpdateButton(false)
    setSaveButton(true)
    setErrors('')
  }

  //=========SAVE HsnCode DATA============
  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!hsnCode.trim()) {
      isValid = false
      errorObj.hsnCode = 'HSN Code is required *'
    }
    if (!type) {
      isValid = false
      errorObj.type = 'Type is required *'
    }
    if (!description.trim()) {
      isValid = false
      errorObj.description = 'Description is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const saveData = {
      hsnCode: hsnCode,
      type: parseFloat(type),
      description: description,
    }

    try {
      const response = await axios.post(
        SaveHSNCodeMaster,
        saveData,
        commonHeaders,
      )

      if (response.data === 'CREATED') {
        toast.success('HsnCode added successfully!')
        fetchHsnCode()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('HsnCode already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT HsnCode DATA============
  const handleEditDataButton = (item) => {
    setUpdateButton(true)
    setSaveButton(false)
    window.scrollTo(0, 0)

    setHsnCodeId(item.id)
    setHsnCode(item.hsnCode)
    setType(String(item.type)) // 👈 fix: set as value, not label
    setDescription(item.description)
  }

  //=========UPDATE HsnCode DATA============
  const handleUpdate = async () => {
    if (!hsnCode || !type || !description) {
      toast.warn('Please fill all fields!')
      return
    }

    const updateData = {
      id: hsnCodeId,
      hsnCode: hsnCode,
      type: parseFloat(type),
      description: description,
    }

    try {
      const response = await axios.put(
        UpdateHSNCodeMaster,
        updateData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('HsnCode updated successfully!')
        fetchHsnCode()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('HsnCode already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE HsnCode DATA============
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the HSN Code "${item.hsnCode}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteHSNCodeMaster}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        toast.success('HsnCode deleted successfully!')
        fetchHsnCode()
        handleCancel()
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the HsnCode')
    }
  }

  const typeOptions = [
    { value: '1', label: 'Sales' },
    { value: '2', label: 'Purchase' },
  ]
  

  return (
    <>
      <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
            <div className="col-12">
              <div className="row px-md-5 mt-3 p-2">
                <div className="col-12 col-lg-4"></div>
                <div className="col-12 col-lg-4">
                  <div className="row p-0 m-0">
                    <div className="col-12 py-1">
                      <label className="labels">HSN Code</label>
                      <Input
                        value={hsnCode}
                        onChange={(e) => setHsnCode(e.target.value)}
                        placeholder="Enter Name"
                      />
                      {errors.hsnCode && (
                        <div className="errorField">{errors.hsnCode}</div>
                      )}
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Type</label>
                      <Select
                          value={type || undefined} 
                          onChange={setType}
                          showSearch
                            className="w-100"
                            placeholder="Select Type"
                            optionFilterProp="children"
                        >
                          {typeOptions.map(opt => (
                            <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                          ))}
                        </Select>

                      {errors.type && (
                        <div className="errorField">{errors.type}</div>
                      )}
                    </div>

                    <div className="col-12 py-1">
                      <label className="labels">Description</label>
                      <Input.TextArea
                        value={description}
                        maxLength="256"
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Enter Description"
                        style={{ width: '100%' }}
                      />
                      {errors.description && (
                        <div className="errorField">{errors.description}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 col-lg-4"></div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {saveButton && (
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}
                  {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </div>

                <div
                  className="col-12 p-0 mt-3"
                  style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
                ></div>
              </div>

              {/*================ Table =========================*/}
              <div className="row m-0 p-2 px-md-5 pt-md-0 mt-3">
                <div
                  className="col-12 py-3 shadow border"
                  style={{ backgroundColor: 'white' }}
                >
                  <div
                    className="col-12 px-md-5"
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div>
                      <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                      <Select
                        defaultValue={pageSize}
                        onChange={handlePageSizeChange}
                        style={{ width: 120, textAlign: 'center' }}
                      >
                        <Option value={10}>10</Option>
                        <Option value={20}>20</Option>
                        <Option value={30}>30</Option>
                      </Select>
                    </div>

                    <div className="pt-4 pt-md-0">
                      <Input.Search
                        placeholder="Search"
                        onChange={(e) => handleSearch(e.target.value)}
                        style={{ width: 200, marginBottom: 16 }}
                      />
                    </div>
                  </div>

                  <div style={{ backgroundColor: 'white' }}>
                    <Table
                      bordered
                      style={{ padding: '0px 20px', overflowX: 'auto' }}
                      columns={columns}
                      dataSource={filteredData}
                      pagination={{
                        pageSize: pageSize,
                        total: totalEntries,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        current: currentPage,
                        onChange: (page) => setCurrentPage(page),
                      }}
                      showSorterTooltip={false}
                      rowKey={(record) => record.id}
                      components={components}
                    />
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default HSNCodeMaster
